
(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('grcControlHistory', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        return {
            scope: boxTmplScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller', function ($scope, $controller) {

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/control/grcControlHistory.[Template].tpl.html';
                $controller('BoxTmplController', { $scope: $scope });

                // Last Changes
                $scope.getLastChangesOnControl = function () {
                    if (!_.isUndefined($scope.boxModel) && $scope.boxModel.length > 0) {
                        return $scope.boxModel[0].Timestamp;
                    }
                }

                $scope.getDifferenceValue = function (versioningControl, differenceName) {
                    return versioningControl[differenceName];
                }

                // Show final level of testing?
                $scope.showFinalLevelOfTestingForControlAssessment = function (controlAssessment) {
                    return controlAssessment.LevelOfTestingFinalID;
                };

                // Show computed level of testing?
                $scope.showFinalLevelOfTestingComputedForControlAssessment = function (controlAssessment) {
                    return $scope.showFinalLevelOfTestingForControlAssessment(controlAssessment) &&
                        (controlAssessment.LevelOfTestingFinalID !== controlAssessment.LevelOfTestingComputedID);
                };
            }],

            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();